import { WixRicosViewer } from '@wix/ricos';
import '@wix/ricos/css/ricos-viewer.global.css';

export default WixRicosViewer;
